import { useEffect } from "react";

export interface UseDocumentTitleOptions {
  /** Constant suffix appended to the title (e.g. " | Simplicity Admin"). */
  suffix?: string;
  /** When false, the hook does not write to `document.title`. */
  enabled?: boolean;
}

/**
 * Write `title` to `document.title` while the calling component is mounted. A null, undefined or
 * empty `title` is a no-op — useful for data-driven pages that call the hook before their async
 * data hydrates; the root-level route-title effect holds the static fallback during that window.
 */
export function useDocumentTitle(
  title: string | null | undefined,
  options: UseDocumentTitleOptions = {},
): void {
  const { suffix = "", enabled = true } = options;
  useEffect(() => {
    if (!enabled) return;
    if (!title) return;
    if (typeof document === "undefined") return;
    document.title = suffix ? `${title}${suffix}` : title;
  }, [title, suffix, enabled]);
}
